import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import {
  FaPlus,
  FaFilter,
  FaRedo,
  FaTrashAlt,
  FaEdit,
  FaSearch,
  FaEye,
  FaDownload
} from "react-icons/fa";

const UserParkingListTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [data, setData] = useState([
    {
      name: "John Doe",
      email: "johndoe@example.com",
      mobile: "123-456-7890",
      vehicleNumber: "ABC-123",
      entry: "10:00 AM",
      exit: "02:00 PM",
      section: "Block 6",
      parking: "A1 Parking",
      lot: "Ground Floor",
    },
    {
      name: "Jane Smith",
      email: "janesmith@example.com",
      mobile: "987-654-3210",
      vehicleNumber: "XYZ-789",
      entry: "11:00 AM",
      exit: "03:00 PM",
      section: "Block 7",
      parking: "B2 Parking",
      lot: "Second Floor",
    },
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.mobile.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.vehicleNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <Card
      className="p-3"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>User Parking List</h4>
        <div className="d-flex align-items-end">
          <Button variant="primary" className="d-flex align-items-center me-3">
            <FaPlus className="me-2" /> Add
          </Button>
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaSearch
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
        </div>
      </div>
      <Card.Body style={{ flexGrow: 1, overflow: "auto" }}>
        <Table striped bordered hover style={{ overflow: "auto" }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Vehicle Number</th>
              <th>Entry</th>
              <th>Exit</th>
              <th>Section</th>
              <th>Parking</th>
              <th>Lot</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.mobile}</td>
                <td>{item.vehicleNumber}</td>
                <td>{item.entry}</td>
                <td>{item.exit}</td>
                <td>{item.section}</td>
                <td>{item.parking}</td>
                <td>{item.lot}</td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      className="border-0"
                    >
                      Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item>
                        <FaEye className="me-2 text-info" /> View
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <FaEdit className="me-2 text-primary" /> Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(index)}>
                        <FaTrashAlt className="me-2 text-danger" /> Delete
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <FaDownload className="me-2 text-success" /> Slip
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
            {!paginatedData.length && (
              <tr>
                <td colSpan="10" className="text-center">
                  No results found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span>
            Showing {startIndex + 1}-
            {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
            {filteredData.length} entries
          </span>
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
            />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
            />
          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UserParkingListTable;
